import React, { useState, useEffect, useContext } from 'react'
import { Link } from "react-router-dom"
import {
  useLocation
} from 'react-router-dom'

import { StateController } from './../../App'

import VerticalCenter from '../VerticalCenter/VerticalCenter'
import Container from '../Container/Container'
import Icon from '../../components/atoms/Icon'
import Profile from '../../components/atoms/Profile'
import useWidth from '../../hooks/useWidth'
import { sendDataLayer } from '../../utils/functions'

function Header({
  page,
  headerType,
  logo,
  items,
  submenu,
  loggedIn,
  logOutAction
}) {
  const { context } = useContext(StateController)
  const { width } = useWidth()
  const location = useLocation()
  const [showOthers, setShowOthers] = useState(false)
  const [hasChildren, setHasChildren] = useState(false)
  const [showMenu, setShowMenu] = useState(false)

  const isSubLevel = (children) => {
    const page = location.pathname.replace('/', '')
    const data = children.find((item) => item.page === page)

    return data ? true : false
  }

  const togglerMenu = (e) => {
    setShowOthers(!showOthers)
    if (e.target.closest('.mc-header-container__nav--item')) {
      let text = e.target.closest('.mc-header-container__nav--item').querySelector('.mc-header-container__nav--button .mc-app-centry > span').innerText
      let link = 'none'

      sendDataLayer({ datalayer: { event: 'menu', text: text, link: link }, repeat: true })
    }

    if (e.target.closest('a')) {
      let text = e.target.closest('a').querySelector('span').innerText
      let link = e.target.closest('a').getAttribute('href')
      sendDataLayer({ datalayer: { event: 'menu', text: text, link: link }, repeat: true })
    }

  }

  const toogleSumMenu = (e) => {
    setShowMenu(!showMenu)
    if (e.target.closest('a')) {
      let text = e.target.closest('a').querySelector('span').innerText
      let link = e.target.closest('a').getAttribute('href')
      sendDataLayer({ datalayer: { event: 'menu', text: text, link: link }, repeat: true })
    }

  }

  const closeSumMenu = () => {
    setShowMenu(false)
  }

  const addDataLayer = (e) => {
    if (e.target.closest('.mc-header-container__nav--item')) {
      let text = e.target.closest('.mc-header-container__nav--item').querySelector('a .mc-app-centry > span').innerText
      let link = e.target.closest('.mc-header-container__nav--item').querySelector('a').getAttribute('href')
      sendDataLayer({ datalayer: { event: 'menu', text: text, link: link }, repeat: true })

      if (text == 'Premio mayor' && link == '/premio-mayor' && width < 992) {
        sendDataLayer({ datalayer: { event: 'cta_premio_mayor_mobile', text: text, link: link }, repeat: true })
      }
    }
  }

  const handleClick = (e) => {
    addDataLayer(e);
    closeSumMenu();
  };

  useEffect(() => {
    const child = items.find((item) => item.sublevel)

    if (child) {
      setHasChildren(child)
    }
  }, [items])

  useEffect(() => {

    window.addEventListener('click', ({ target }) => {
      const window = target.closest('.mc-header-container__nav--extra')
      const button = target.closest('.mc-header-container__nav--button')

      if (window === null && button === null) setShowOthers(false)
    })
  }, [])

  const closeSession = () => {
    logOutAction()
    setShowOthers(false)
    sendDataLayer({ datalayer: { event: 'menu', text: 'Cerrar sesión', link: '/' }, repeat: true })
  }

  return (
    <div
      className={`
      mc-header-container mc-header-container-type-${headerType} 
      mc-header-container-page-${page !== '' ? page ? page : 'login' : 'login'} 
      ${showMenu ? 'show-menu' : ''}`
      }>
      <div className='mc-header-container__menu'>
        <Container fullHeight={true}>

          <a className="mc-header-container__logo" href="/">
            <VerticalCenter>
              <img src={`/assets/images/${logo}`} alt="Logo Banco de Occidente" />
            </VerticalCenter>

            <div className='percentMobileGlobal'>
              Hemos entregado el <strong>97%</strong> de bonos
            </div>
          </a>

          {headerType === 1 && loggedIn &&
            <div className="mc-header-container__mobile--close" onClick={closeSession}>
              <VerticalCenter>
                <Icon name="close_session" />
              </VerticalCenter>
            </div>
          }

          {headerType === 4 &&
            <div className="mc-header-container__mobile--submenu" onClick={toogleSumMenu}>
              <VerticalCenter>
                <Icon name="menu" />
              </VerticalCenter>
            </div>
          }

          <nav className="mc-header-container__nav">
            {headerType === 4 &&
              <div
                className="mc-header-container__mobile--overlay"
                onClick={closeSumMenu}
              >
              </div>
            }
            {headerType === 4 &&
              <div className="mc-header-container__nav--close" onClick={closeSumMenu}>
                <Icon name="close" />
              </div>
            }

            {loggedIn
              ? <ul className='containerMenuNav'>
                <hr className="custom-hr" />
                {items.filter((item) => {
                  if (item?.component?.props?.privatePage || item?.sublevel) {
                    return true
                  } else {
                    return width < 992 ? true : false
                  }
                }).map((item, index) => {
                  return (
                    item.sublevel
                      ? <li
                        className={`mc-header-container__nav--item slow_ani ${item.page} ${((showOthers) || (isSubLevel(item.children))) ? 'mc-header-container__nav--item-active' : ''}`}
                        onClick={togglerMenu}
                        key={index}
                      >
                        <div className="mc-header-container__nav--button">
                          <VerticalCenter>
                            <span>
                              {item.icon &&
                                <Icon name={item.icon} />
                              }
                              {item.title}
                            </span>
                          </VerticalCenter>
                        </div>
                      </li>
                      : <li
                        className={`mc-header-container__nav--item item-${item.page} slow_ani ${location.pathname.replace('/', '') === item.page && !showOthers ? 'mc-header-container__nav--item-active' : ''} ${item.highlight ? 'highlight' : ''} ${window.location.pathname === '/premio-mayor' ? 'noshow' : ''}`}
                        onClick={handleClick}
                        key={index}
                      >
                        <Link to={`/${item.page}`}>
                          <VerticalCenter>
                            <span>
                              {item.highlight &&
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.3337 15.8333H6.66699V17.0833C6.66699 17.4148 6.5353 17.7328 6.30088 17.9672C6.06645 18.2016 5.74851 18.3333 5.41699 18.3333H4.58366C4.25214 18.3333 3.9342 18.2016 3.69978 17.9672C3.46535 17.7328 3.33366 17.4148 3.33366 17.0833V15.6917C2.8461 15.5191 2.42401 15.1997 2.12553 14.7774C1.82704 14.355 1.66684 13.8505 1.66699 13.3333V10.8333C1.66699 10.3167 1.82366 9.83666 2.09199 9.43832L2.99699 3.77166C3.09097 3.18431 3.39129 2.64972 3.84401 2.2639C4.29673 1.87808 4.87217 1.66632 5.46699 1.66666H14.5337C15.128 1.66715 15.7028 1.87938 16.1548 2.2653C16.6069 2.65121 16.9066 3.18556 17.0003 3.77249L17.9028 9.43082C18.1745 9.83082 18.3328 10.3142 18.3328 10.8333V13.3333C18.333 13.8505 18.1728 14.355 17.8743 14.7774C17.5758 15.1997 17.1537 15.5191 16.6662 15.6917V17.0833C16.6662 17.4148 16.5345 17.7328 16.3 17.9672C16.0656 18.2016 15.7477 18.3333 15.4162 18.3333H14.5828C14.2513 18.3333 13.9334 18.2016 13.6989 17.9672C13.4645 17.7328 13.3328 17.4148 13.3328 17.0833V15.8333H13.3337ZM4.16699 14.1667H15.8337C16.0547 14.1667 16.2666 14.0789 16.4229 13.9226C16.5792 13.7663 16.667 13.5543 16.667 13.3333V10.8333C16.667 10.6123 16.5792 10.4003 16.4229 10.2441C16.2666 10.0878 16.0547 9.99999 15.8337 9.99999H4.16699C3.94598 9.99999 3.73402 10.0878 3.57774 10.2441C3.42146 10.4003 3.33366 10.6123 3.33366 10.8333V13.3333C3.33366 13.5543 3.42146 13.7663 3.57774 13.9226C3.73402 14.0789 3.94598 14.1667 4.16699 14.1667ZM16.042 8.34166L15.3553 4.03499C15.324 3.83949 15.2242 3.66152 15.0736 3.53295C14.9231 3.40437 14.7316 3.33361 14.5337 3.33332H5.46616C5.26789 3.33321 5.07607 3.4038 4.92516 3.5324C4.77426 3.66101 4.67415 3.83921 4.64283 4.03499L3.95533 8.34249C4.02572 8.33648 4.09634 8.33343 4.16699 8.33332H15.8337C15.9037 8.33332 15.9737 8.33582 16.042 8.34166ZM14.5837 11.6667C14.4732 11.6667 14.3672 11.7106 14.289 11.7887C14.2109 11.8668 14.167 11.9728 14.167 12.0833C14.167 12.1938 14.2109 12.2998 14.289 12.378C14.3672 12.4561 14.4732 12.5 14.5837 12.5C14.6942 12.5 14.8001 12.4561 14.8783 12.378C14.9564 12.2998 15.0003 12.1938 15.0003 12.0833C15.0003 11.9728 14.9564 11.8668 14.8783 11.7887C14.8001 11.7106 14.6942 11.6667 14.5837 11.6667ZM14.5837 13.3333C14.4195 13.3333 14.257 13.301 14.1053 13.2382C13.9536 13.1754 13.8158 13.0833 13.6998 12.9672C13.5837 12.8511 13.4916 12.7133 13.4288 12.5617C13.366 12.41 13.3337 12.2475 13.3337 12.0833C13.3337 11.9192 13.366 11.7566 13.4288 11.605C13.4916 11.4533 13.5837 11.3155 13.6998 11.1994C13.8158 11.0834 13.9536 10.9913 14.1053 10.9285C14.257 10.8657 14.4195 10.8333 14.5837 10.8333C14.9152 10.8333 15.2331 10.965 15.4675 11.1994C15.702 11.4339 15.8337 11.7518 15.8337 12.0833C15.8337 12.4148 15.702 12.7328 15.4675 12.9672C15.2331 13.2016 14.9152 13.3333 14.5837 13.3333ZM5.41699 11.6667C5.30648 11.6667 5.2005 11.7106 5.12236 11.7887C5.04422 11.8668 5.00033 11.9728 5.00033 12.0833C5.00033 12.1938 5.04422 12.2998 5.12236 12.378C5.2005 12.4561 5.30648 12.5 5.41699 12.5C5.5275 12.5 5.63348 12.4561 5.71162 12.378C5.78976 12.2998 5.83366 12.1938 5.83366 12.0833C5.83366 11.9728 5.78976 11.8668 5.71162 11.7887C5.63348 11.7106 5.5275 11.6667 5.41699 11.6667ZM5.41699 13.3333C5.25284 13.3333 5.09029 13.301 4.93864 13.2382C4.78698 13.1754 4.64918 13.0833 4.53311 12.9672C4.41704 12.8511 4.32496 12.7133 4.26214 12.5617C4.19932 12.41 4.16699 12.2475 4.16699 12.0833C4.16699 11.9192 4.19932 11.7566 4.26214 11.605C4.32496 11.4533 4.41704 11.3155 4.53311 11.1994C4.64918 11.0834 4.78698 10.9913 4.93864 10.9285C5.09029 10.8657 5.25284 10.8333 5.41699 10.8333C5.74851 10.8333 6.06645 10.965 6.30088 11.1994C6.5353 11.4339 6.66699 11.7518 6.66699 12.0833C6.66699 12.4148 6.5353 12.7328 6.30088 12.9672C6.06645 13.2016 5.74851 13.3333 5.41699 13.3333ZM6.00366 4.24499C6.22467 4.24499 6.43663 4.33279 6.59291 4.48907C6.74919 4.64535 6.83699 4.85731 6.83699 5.07832V6.74499C6.83699 6.966 6.74919 7.17797 6.59291 7.33425C6.43663 7.49053 6.22467 7.57832 6.00366 7.57832C5.78264 7.57832 5.57068 7.49053 5.4144 7.33425C5.25812 7.17797 5.17033 6.966 5.17033 6.74499V5.07832C5.17033 4.85731 5.25812 4.64535 5.4144 4.48907C5.57068 4.33279 5.78264 4.24499 6.00366 4.24499Z" fill="#333333"/>
                                </svg>                                
                              }
                              {item.icon &&
                                <Icon name={item.icon} />
                              }
                              {item.title}
                            </span>
                          </VerticalCenter>
                        </Link>
                      </li>
                  )
                })}
                <li className='mc-header-container__nav--item slow_ani'>
                </li>
                <hr className="custom-hr" />
                <button className='sesionCloseBtn' onClick={closeSession}>Cerrar sesión <img src={`/assets/images/move_item.png`} alt="" /></button>
              </ul>
              : <ul>

                {items.filter((item) => {
                  if (item?.component?.props?.privatePage || item?.sublevel) {
                    return false
                  } else {
                    return true
                  }
                }).map((item, index) => {
                  return (
                    <li
                      className={`mc-header-container__nav--item item-${item.page} slow_ani ${location.pathname.replace('/', '') === item.page && !showOthers ? 'mc-header-container__nav--item-active' : ''}`}
                      onClick={addDataLayer}
                      key={index}
                    >
                      <Link to={`/${item.page}`}>
                        <VerticalCenter>
                          <span>
                            {item.icon &&
                              <Icon name={item.icon} />
                            }
                            {item.title}
                          </span>
                        </VerticalCenter>
                      </Link>
                    </li>
                  )
                })}

                <li className={`mc-header-container__nav--item-active slow_ani`}>
                  <Link to="/" className='mc-header-link'>
                    {/* <span>Ingresar</span> */}
                  </Link>
                </li>
              </ul>
            }

            {hasChildren &&
              <div className={`mc-header-container__nav--extra slow_ani ${showOthers ? 'opened' : ''}`}>
                {hasChildren.children.map((item, index) => {
                  return (
                    <Link to={`/${item.page}`} key={index} onClick={togglerMenu}>
                      <span>
                        {item.icon &&
                          <Icon name={item.icon} />
                        }
                        {item.title}
                      </span>
                    </Link>
                  )
                })}
                <div className="mc-header-container__nav--close" onClick={closeSession}>
                  Cerrar sesión <img style={{ verticalAlign: 'sub' }} src={`/assets/images/move_item.png`} />
                </div>
              </div>
            }
          </nav>
        </Container>
      </div>

      {submenu &&
        <div className={`mc-header-container__submenu ${!loggedIn ? 'not-login' : ''}`}>
          <Container fullHeight={true}>
            <VerticalCenter>
              {submenu.type === 'labels' &&
                <>
                  {submenu.icon && <Icon name={submenu.icon} />}
                  <div dangerouslySetInnerHTML={{ __html: submenu.content }} />
                </>
              }
              {submenu.type === 'nickname' && loggedIn && context?.user?.nickname &&
                <Profile
                  nickname={context.user.nickname}
                  defaultLetter={submenu.default}
                />
              }
            </VerticalCenter>
          </Container>
        </div>
      }
    </div>
  )
}

export default Header